export default "__VITE_ASSET__DepdR4Q___"